export default __webpack_public_path__ + "media/images/ui-icons_cd0a0a_256x240-d16b97b73ab78049e037bea51f6aff10.png";